import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function IvyLeagueTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-10 shadow-2xl text-[13px] leading-relaxed font-serif" data-testid="resume-live-preview">
      <div className="text-center border-b-2 border-double pb-4 mb-5" style={{ borderColor: "#1e293b" }}>
        <h1 className="text-2xl font-bold tracking-wide">{draft.full_name || "Your Name"}</h1>
        <p className="text-slate-600 text-[12px] mt-1">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        {draft.target_role && <p className="text-[12px] italic mt-1" style={{ color: accent }}>{draft.target_role}</p>}
      </div>

      {draft.summary && (
        <div className="mb-4">
          <h2 className="text-[12px] font-bold uppercase tracking-widest border-b mb-1.5" style={{ borderColor: accent }}>Summary</h2>
          <p className="text-slate-700">{draft.summary}</p>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mb-4">
          <h2 className="text-[12px] font-bold uppercase tracking-widest border-b mb-1.5" style={{ borderColor: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-2.5">
              <div className="flex justify-between">
                <p className="font-semibold">{e.title}, {e.company}</p>
                <p className="text-slate-500 italic text-[12px]">{dateRange(e.start_date, e.end_date, e.current)}</p>
              </div>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-4">
          <h2 className="text-[12px] font-bold uppercase tracking-widest border-b mb-1.5" style={{ borderColor: accent }}>Education</h2>
          {draft.education.map((ed, i) => (
            <div key={i} className="flex justify-between mb-1">
              <p>{ed.degree} {ed.field}, {ed.school}</p>
              <p className="text-slate-500 italic text-[12px]">{dateRange(ed.start_date, ed.end_date)}</p>
            </div>
          ))}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mb-4">
          <h2 className="text-[12px] font-bold uppercase tracking-widest border-b mb-1.5" style={{ borderColor: accent }}>Skills</h2>
          <p className="text-slate-700">{draft.skills.join(" · ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
